import { MasterDataFetchCustomQueryParams, MasterDataRowType } from 'src/types/apps/masterdataTypes';
import { GetAxiosInstance } from '../baseService';
import { ConvertServiceLocationToEnum, ServiceLocation } from '../serviceLocationsAxios';
import {
  GetCountryLookupQueryParams,
  GetNonWorkingDayQueryParams,
  NonWorkingDayDto,
  TransitTimesViewDto
} from 'src/models/masterdata';

// get the data rows for a specific master data table
export const getMasterDataTableRows = async (
  params: MasterDataFetchCustomQueryParams,
  tenantId?: string,
  partnerId?: string
) => {
  return GetAxiosInstance(undefined, tenantId, partnerId, undefined, undefined, 180000).get<any>(
    ConvertServiceLocationToEnum(params.serviceLocation) + '/' + params.endPoint,
    {
      params
    }
  );
};

// get the master data item we are retrieving from the DBX
export const getMasterDataRow = async (params: MasterDataRowType, tenantId?: string, partnerId?: string) => {
  return GetAxiosInstance(undefined, tenantId, partnerId).get(
    ConvertServiceLocationToEnum(params.serviceLocation) +
      '/' +
      params.endPoint +
      '/' +
      (params.id != undefined ? params.id : ''),
    { params }
  );
};

// update the masterdata we have edited
export const updateMasterDataRow = (params: MasterDataRowType) => {
  return GetAxiosInstance().put(
    ConvertServiceLocationToEnum(params.serviceLocation) + '/' + params.endPoint + '/' + params.data.id,
    params.data
  );
};

// add new masterdata
export const addMasterDataRow = (params: MasterDataRowType) => {
  return GetAxiosInstance().post(
    ConvertServiceLocationToEnum(params.serviceLocation) + '/' + params.endPoint,
    params.data
  );
};

// delete the masterdata row
export const deleteMasterDataRow = (params: MasterDataRowType) => {
  return GetAxiosInstance().delete(
    ConvertServiceLocationToEnum(params.serviceLocation) + '/' + params.endPoint + '/' + params.data.id,
    { data: params.data }
  );
};

export const bulkAddMasterDataRows = (params: MasterDataRowType) => {
  return GetAxiosInstance(undefined, undefined, undefined, undefined, undefined, 180000).put(
    ConvertServiceLocationToEnum(params.serviceLocation) + '/' + params.endPoint,
    params.data
  );
};

/**
 * Get Transit Times
 */
export const getTransitTimes = () => {
  return GetAxiosInstance().get<TransitTimesViewDto[]>(ServiceLocation.masterdata + '/TransitTimes');
};

/**
 * NonWorkingDays
 *
 * @param params
 * @returns
 */
export const getNonWorkingDays = async (params?: GetNonWorkingDayQueryParams) => {
  return GetAxiosInstance().get<NonWorkingDayDto[]>(ServiceLocation.masterdata + '/NonWorkingDay', { params });
};

/**
 * Country Lookup
 *
 * @param params
 * @returns
 */
export const getCountryLookup = async (params: GetCountryLookupQueryParams) => {
  return GetAxiosInstance().get(ServiceLocation.masterdata + '/Country/lookup', { params });
};
